import { Component, computed, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UnpaidPaymentsAccessService } from './unpaid-payments-access.service';
import { UnpaidPaymentsHubProductCardComponent } from './components/unpaid-payments-hub-product-card.component';
import { UnpaidPaymentsHubOverviewService } from './unpaid-payments-hub-overview.service';
import { readUnpaidPaymentsRouteProductKeys } from './unpaid-payments-route.config';

@Component({
  selector: 'app-unpaid-payments-overview-stub',
  standalone: true,
  imports: [UnpaidPaymentsHubProductCardComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './unpaid-payments-overview-stub.component.html',
})
export class UnpaidPaymentsOverviewStubComponent implements OnInit {
  private readonly hubOverviewService = inject(UnpaidPaymentsHubOverviewService);
  private readonly accessService = inject(UnpaidPaymentsAccessService);
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);

  readonly cards = this.hubOverviewService.cards;

  readonly visibleCards = computed(() => {
    const routableKeys = readUnpaidPaymentsRouteProductKeys();
    return this.cards().filter((card) => routableKeys.has(card.product.key));
  });

  readonly deniedProductLabels = computed(() => {
    const labels = new Set<string>();
    const routableKeys = readUnpaidPaymentsRouteProductKeys();

    for (const product of this.accessService.unauthorizedProducts()) {
      if (routableKeys.has(product.key)) {
        labels.add(product.label);
      }
    }

    for (const card of this.visibleCards()) {
      if (!card.loading && card.unauthorized) {
        labels.add(card.product.label);
      }
    }

    return [...labels];
  });

  readonly showAccessBanner = computed(() => this.deniedProductLabels().length > 0);

  readonly allAccessDenied = computed(
    () => this.deniedProductLabels().length > 0 && !this.accessService.hasAnyAccess()
  );

  ngOnInit(): void {
    this.hubOverviewService.prepareOverviewCards();
    this.hubOverviewService.loadCards();
  }

  openProduct(routeSegment: string): void {
    const productKey = this.accessService.productKeyForRouteSegment(routeSegment);
    if (productKey && !this.accessService.hasAccess(productKey)) {
      return;
    }
    this.router.navigate(['..', routeSegment], { relativeTo: this.route });
  }
}
